import { combineReducers } from 'redux';
import authReducer from "../features/auth/authSlice";
import generalReducer from '../components/general/generalSlice';
import qrCodeReducer from '../features/qrCode/qrCodeSlice';
import employeesReducer from '../features/employees/employeeSlice';
import contactsReducer from '../features/contact/contactSlice';
import templatesReducer from '../features/templates/templatesSlice';
import chatBotReducer from '../features/chatBot/chatBotSlice';
import campaignsReducer from '../features/campaign/campaignSlice';
import fileCategoriesReducer from '../features/files/filesSlice';
import leadManagementReducer from '../features/leadMangement/leadMangementSlice';
import messagesReducer from '../features/messages/messagesSlice';
import organizatiomFormReducer from '../features/form/formsSlice';
import crmQuotationReducer from '../features/crm-quotations/quotationSlice';
import appointmentReducer from '../features/appointmentSlotBooking/slotBookingSlice';

const appReducer = combineReducers({
    authentication: authReducer,
    general: generalReducer,
    qrCode: qrCodeReducer,
    employees: employeesReducer,
    contacts: contactsReducer,
    templates: templatesReducer,
    chatBot: chatBotReducer,
    campaigns: campaignsReducer,
    fileCategories: fileCategoriesReducer,
    leadManagement: leadManagementReducer,
    messages: messagesReducer,
    organizatiomForm: organizatiomFormReducer,
    crmQuotation: crmQuotationReducer,
    appointment: appointmentReducer
});

const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE') {
        state = undefined; // resets all slices to their initial state
    }
    return appReducer(state, action);
};

export default rootReducer;
